import { Injectable } from '@angular/core';
import {
  AuthService,
  EventService,
  GlobalMessageService,
  GlobalMessageType,
  LogoutEvent,
  RoutingService,
} from '@spartacus/core';
import { take } from 'rxjs';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  constructor(
    protected routingService: RoutingService,
    protected authService: AuthService,
    private globalMessageService: GlobalMessageService,
    protected eventService: EventService,
    private storageService: StorageService
  ) {}

  logout(): void {
    this.storageService.removeLocalStorageItem('lastAuthTime');
    this.authService.logout();
    this.eventService
      .get(LogoutEvent)
      .pipe(take(1))
      .subscribe(() => {
        this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION);
      });
  }
}
